import { SET_POSTCODE } from "../actionTypes";

const initialState = "";

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_POSTCODE: {
      return action.payload;
    }
    default:
      return state;
  }
};
